(function($) {
    /**Menu**/
    function customSubMenu() {
        $(".nav-dropdown.nav-dropdown--first").each(function(index) {

            if (!$(this).find(".nav-dropdown--second").length) {
                $(this).parent().addClass("not-dropdown-second");
            }
        });

    }

    customSubMenu();

    /**Search page**/
    $('.search__form .input-group__submit').on('click', function() {
        var input_search = $(".search__form .form__input").val().replace("/", " ");
        $(".search__form .form__input").val(input_search);
    });

    /**Tooltip**/
    $(".price-tooltip, .point-tooltip").mouseover(function() {
        if ($(window).innerWidth() > 800) {
            var scrollTop = $(window).scrollTop(),
                elementOffset = $(this).offset().top,
                distance = elementOffset - scrollTop,
                tooltip = $(this).next(),
                heightTooltip = tooltip.height(),
                heightWindow = $(window).innerHeight();

            tooltip.removeClass("move-to-top");
            tooltip.removeClass("move-to-bottom");

            if (distance + heightTooltip >= heightWindow) {
                var newPosition = 0;
                //update position tooltip
                tooltip.addClass("move-to-top");
            } else if (distance <= heightTooltip) {
                tooltip.addClass("move-to-bottom");
            } else {
                tooltip.removeClass("new-position");
            }
        }
    });


    /**FOOTER**/
    $('.menu_links > h2').on('click', function() {
        var parent = $(this).parent(),
            windowWidth = window.innerWidth;

        if (windowWidth <= 800) {
            parent.toggleClass("open");
        }

    });


    /**Home page**/

    /**New product**/
    var initNewProducts = function(domElement) {
        if (domElement.length === 0) {
            return;
        }

        domElement.slick({
            dots: false,
            arrows: true,
            adaptiveHeight: false,
            mobileFirst: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false,
            accessibility: false,
            useCSS: true,
            prevArrow: '<button title="Prev" class="fs-slideshow__nav-button fs-slideshow__nav-prev slick-prev"><span>Prev</span><svg class="icon icon-arrow-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use></svg></button>',
            nextArrow: '<button title="Next" class="fs-slideshow__nav-button fs-slideshow__nav-next slick-next"><span>Next</span><svg class="icon icon-arrow-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use></svg></button>',
            responsive: [
              {
                breakpoint: 560,
                settings: {
                  slidesToShow: 2
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 3
                }
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 4
                }
              }
            ]

        })
    };



    /**Promotion Products**/
    var initPromotion = function(domElement) {
        domElement.find('.list-products').slick('unslick');
    };


    if ($("body").hasClass("template-index")) {
        initPromotion($('.shopify-section__promotions-product'));
        initNewProducts($('.section-new-products .list-products'));
    }


    /**Recently Viewed Item**/
    var initRecentViewed = function(domElement) {
        if (domElement.length === 0) {
            return;
        }

        domElement.slick({
            dots: false,
            arrows: true,
            adaptiveHeight: false,
            mobileFirst: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false,
            accessibility: false,
            useCSS: true,
            prevArrow: '<button title="Prev" class="fs-slideshow__nav-button fs-slideshow__nav-prev slick-prev"><span>Prev</span><svg class="icon icon-arrow-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use></svg></button>',
            nextArrow: '<button title="Next" class="fs-slideshow__nav-button fs-slideshow__nav-next slick-next"><span>Next</span><svg class="icon icon-arrow-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use></svg></button>',
            responsive: [
              {
                breakpoint: 560,
                settings: {
                  slidesToShow: 2
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 3
                }
              },
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 4
                }
              },
              {
                breakpoint: 1199,
                settings: {
                  slidesToShow: 5
                }
              },
              {
                breakpoint: 1349,
                settings: {
                  slidesToShow: 6
                }
              }
            ]

        })
    };

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return 1;
    };

    $(document).ready(function() {
        if ($("#recently-viewed-products").hasClass("slick-initialized")) {
            $("#recently-viewed-products").slick("unslick");
        }
        initRecentViewed($('#recently-viewed-products'));

        if ($("body").hasClass("template-page-discount-codes")) {
            var currentPage = getUrlParameter('page');

            getDiscountList(currentPage);

        }

        //remove provine
        if ($(".address_form").length) {
            $(".address_form").find('option[value="Putrajaya"]').remove();
        }


        if ($(".review-tab-title").length) {
            $(".review-tab-title").hide();
            $(".review-tab-m").parents(".tabs__nav-item-m").hide();
        }

        $(".review-tab-title").on("click", function() {
          const detail = {
            type: 'reviewsClick',
            label: ''
          }
          dispatchEvent(detail);
          showReview(false);
        });



        checkRating();

        if ($("body").hasClass("template-product")) {
            if ($(".review-tab-title").hasClass("active")) {
                showReview(true);
            } else {
                showReview(false);
            }
        }

    });

    /**Disable Scroll on mobile**/

    function disableScroll() {
        $('.header__nav-toggle').on('touchmove', function(evt) {
            evt.preventDefault();
        });
    }

    function enableScroll() {
        $('.header__nav-toggle').off('touchmove', function(evt) {
            evt.preventDefault();
        });
    }

    $('.header__nav-toggle').on('click', function(evt) {
        checkDevice();
    });

    function checkDevice() {
        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        if (windowWidth <= 1024 && $('.sidebar-nav').hasClass('sidebar-nav--open')) {
            disableScroll();
        } else {
            enableScroll();
        }
    }

    function closeMinicart() {
        if (headerSearch.hasClass('header-search--open')) {
            headerSearch.removeClass('header-search--open');
        }
        if (miniCart.hasClass('mini-cart--open')) {
            miniCart.removeClass('mini-cart--open');
        }
        if (userLink.hasClass('open')) {
            userLink.removeClass('open');
            navUser.hide();
        }

        $('.page__overlay').removeClass('page__overlay--open');

        $("body").removeClass('no-scroll');

    }

    $('.page__overlay').bind('touchstart', function(e) {
        closeMinicart();
    });

    // AA tracking button for mini cart
    $(document).on("click", '.close-minicart', function(event) {
      const detail = {
        type: 'continueShopping',
        label: 'continueShopping'
      }
      dispatchEvent(detail);
      closeMinicart();
    });
  
    $(document).on("click", '.mini-cart__buttons .button--checkout', function (event) {
      const detail = {
        type: 'proceedCheckout',
        label: 'proceedCheckout'
      }
      dispatchEvent(detail);
    });

    $(window).resize(function() {
        //    	initNewProducts($('.section-new-products .list-products'));
        initRecentViewed($('#recently-viewed-products'));

        if ($("body").hasClass("template-index")) {
            initNewProducts($('.section-new-products .list-products'));
        }
        checkDevice();
        showCodeContent(true);
        showReview(false);
    });

    /**Nav User Drop Down in Header**/
    var userLink = $('.user__link');
    var userDropdown = userLink.find('.link');
    var navUser = userLink.find('.nav-dropdown');
    var miniCart = $(".mini-cart");
    var headerSearch = $(".header-search");


    $(document).click(function(e) {

        if (!e) e = window.event;

        if ($(e.target).hasClass("nav-dropdown__link")) {
            //sub menu
            window.location.href = $(e.target).attr("href");
        } else if ($(e.target).hasClass("user__link") || $(e.target).parents(".user__link").length ||
            $(e.srcElement).parents(".user__link").length ||
            $(e.srcElement).hasClass("user__link")) {

            if (headerSearch.hasClass('header-search--open')) {
                headerSearch.removeClass('header-search--open');
            }

            if (miniCart.hasClass('mini-cart--open')) {
                miniCart.removeClass('mini-cart--open');
            }

            if (userLink.hasClass('open')) {
                userLink.removeClass('open');
                $("body").removeClass('no-scroll');
                navUser.hide();
                $('.page__overlay').removeClass('page__overlay--open');
            } else {
                userLink.addClass('open');
                $("body").addClass('no-scroll');
                navUser.show();
                $('.page__overlay').addClass('page__overlay--open');
            }
        } else if ($(e.target).hasClass("search-form") || $(e.target).parents(".search-form").length) {

            if (miniCart.hasClass('mini-cart--open')) {
                miniCart.removeClass('mini-cart--open');
            }

            if (userLink.hasClass('open')) {
                userLink.removeClass('open');
                navUser.hide();

            }
        } else {
            if ($(e.target).hasClass("page__overlay")) {
                if (headerSearch.hasClass('header-search--open')) {
                    headerSearch.removeClass('header-search--open');
                }
                if (miniCart.hasClass('mini-cart--open')) {
                    miniCart.removeClass('mini-cart--open');
                }
                if (userLink.hasClass('open')) {
                    userLink.removeClass('open');
                    navUser.hide();
                }
                $('.page__overlay').removeClass('page__overlay--open');
                $("body").removeClass('no-scroll');
            } else if ($(e.target).hasClass("mini-cart-menu") || $(e.target).parents(".mini-cart-menu").length) {
                if (headerSearch.hasClass('header-search--open')) {
                    headerSearch.removeClass('header-search--open');
                }
                if (userLink.hasClass('open')) {
                    userLink.removeClass('open');
                    navUser.hide();
                }
            }
        }

    });

    function phone_validate(phno) {
        var regexPattern = new RegExp(/^[0-9]+$/); // regular expression pattern
        return regexPattern.test(phno);
    }

    // AA tracking

    /**Cart event for PDP & Collection page */
    async function fireCartEvent(type, skuProd, parentBtn) {
      var dataGWTProduct;

      try {
        dataGWTProduct = await getGWTdataProductDetail(`${skuProd}`);
      } catch (error) {
        dataGWTProduct = null;   
      }

      const sellingPrice = Shopify.formatMoney($(parentBtn.find(`input[name="single-price"]`)).val()).replace(/[^0-9.,]/g, '');

      const dataDetail = {
        type: type,
        sku: skuProd,
        model: $(parentBtn.find(`input[name="model_"]`)).val(),
        superModel: $(parentBtn.find(`input[name="superModel_"]`)).val(),
        category: $(parentBtn.find(`input[name="sixdcode_"]`)).val(),
        gwCategory1: dataGWTProduct?.data?.mainCategory?.[0] || '',
        gwCategory2: dataGWTProduct?.data?.mainCategory?.[1] || '',
        gwCategory3: dataGWTProduct?.data?.mainCategory?.[2] || '',
        gwSku: dataGWTProduct?.data?.sku || '',
        gwModel: dataGWTProduct?.data?.modelName || '',
        gwSupermodel: dataGWTProduct?.data?.superModelName || '',
        selling_price: sellingPrice,
        price: Shopify.formatMoney($(parentBtn.find(`input[name="single-compare-at-price"]`)).val()).replace(/[^0-9.,]/g, '') || sellingPrice,
        loyaltypoints: (Number(sellingPrice?.replace(/,/g, '')) * 1 || '').toString()
      };

      var event = new CustomEvent("cartEvent", {
        detail: dataDetail
      });

      document.dispatchEvent(event);
    }

    function trackingCartEvent() {
      const btnTracking = $('.product__details .quantity-selector a, .product__details a.wishlist_collections');

      btnTracking.on('click', async function (e) {
        const dataType = $(this).attr('data-action');
        const parentBtn = $(this).parents(".product__details");
        let skuProd;
        let type;

        switch(dataType) {
          case 'decrease-product-quantity':
            skuProd = $(parentBtn.find('input[name^="sku"]')).val();
            type = 'unitChangeMinus';
            break;
          case 'increase-product-quantity':
            skuProd = $(parentBtn.find('input[name^="sku"]')).val();
            type = 'unitChangePlus';
            break;
          case 'wishlist':
            skuProd = $(this).attr('variant-sku');
            if ($(this).hasClass("wishlist_collections") && $(this).hasClass( "btn-active")) {
              type = 'favoriteRemove';
            } else {
              type = 'favoriteAdd';
            }
            break;
          }
          await fireCartEvent(type, skuProd, parentBtn);
      })

      const btnAddWishListPerItem = $('.product-item a.wishlist_collections');

      btnAddWishListPerItem.on('click', async function () {
        let type;
        const parentBtn = $(this).parents(".product-item__info");
        let skuProd = $(this).attr('variant-sku');

        if ($(this).hasClass("wishlist_collections") && $(this).hasClass( "btn-active")) {
          type = 'favoriteRemove';
        } else {
          type = 'favoriteAdd';
        }

        await fireCartEvent(type, skuProd, parentBtn);
      })
    }

    trackingCartEvent();

    $(".header__logo-link, .header__main-nav a.link, .nav-dropdown__item a.nav-dropdown__link").click(function () {
      let detail = {};
      if ($(this).hasClass("header__logo-link")) {
        detail = {
          type: 'headerHome',
          label: ''
        };
      } else {
        const name = $(this).attr("data-title");
        detail = {
          type: 'headerCategory',
          label: name
        };
      }
      dispatchEvent(detail);
    });

    $(`.header__link.search-form a.link, .header__link.wishlist a.link, .header__link.mini-cart-menu a.link, 
    .header__link.user__link a.nav-dropdown__link.link`).click(function () {
      let detail;
      if ($(this).attr('aria-label') === 'Search') {
        detail = {
          type: 'headerSearch',
          label: ''
        };
      } else if ($(this).attr('href') === '/pages/wishlist') {
        detail = {
          type: 'headerWishlist',
          label: ''
        };
      } else if ($(this).attr('aria-label') === 'Cart') {
        detail = {
          type: 'headerCart',
          label: ''
        };
      } else if ($(this).attr('alt') === 'Sign In') {
        detail = {
          type: 'headerSignIn',
          label: ''
        };
      } else if ($(this).attr('alt') === 'Register') {
        detail = {
          type: 'headerRegister',
          label: ''
        };
      }

      if (detail) {
        dispatchEvent(detail);
      }
    });

    $(`.fs-slideshow__nav-button.fs-slideshow__nav-prev.slick-prev[alt="Prev"], 
    .fs-slideshow__nav-button.fs-slideshow__nav-next.slick-next[alt="Next"]`).click(function () {
      let detail;
      const type = $(this).attr("alt");
      if (type === "Next") {
        detail = {
          type: 'sliderArrow',
          label: 'Next'
        };
      } else {
        detail = {
          type: 'sliderArrow',
          label: 'Previous'
        };
      }
      dispatchEvent(detail);
    });

    $('.product-item__see-more.button-wrapper, .product-item__title a[class="link"]').click(function () {
      let modelName;
      if ($(this).is('.product-item__see-more, .button-wrapper')) {
        modelName = $(this).parent().find('.product-item__info .product-item__title a[class="link"]').html();
      } else {
        modelName = $(this).html();
      }

      const detail = {
        type: 'viewDetail',
        label: modelName
      };
      dispatchEvent(detail);
    });

    $('.collection__filter.styled-select.collection-sort-by select').change(function () {
      const detail = {
        type: 'sortingClick',
        label: ''
      };
      dispatchEvent(detail);
    });

    $('.fs-slideshow__plyr-container').click(function() {
      const titleVideo = $(this).find('iframe').attr('title');
      const detail = {
        type: 'videoClick',
        label: titleVideo
      }
      dispatchEvent(detail);
    });

    $(`#shopify-section-product-template .fs-slideshow__nav-button.fs-slideshow__nav-prev.slick-prev.slick-arrow, 
    #shopify-section-product-template .fs-slideshow__nav-button.fs-slideshow__nav-next.slick-next.slick-arrow`).click(function () {
      let sliderArrow;
      const type = $(this).attr("title");
      if (type == "Prev") {
        sliderArrow = "Previous";
      } else {
        sliderArrow = "Next";
      }

      const detail = {
        type: 'sliderArrow',
        label: sliderArrow
      }
      dispatchEvent(detail);
    });

    $('.styled-select.styled-select--secondary select.single-option-selector').change(function () {
      const sizeSelect = $(this).val();
      const detail = {
        type: 'screenSize',
        label: sizeSelect
      }
      dispatchEvent(detail);
    });

    $('.product__slide-wrapper').click(function() {
      const detail = {
        type: 'carouselClick',
        label: ''
      }
      dispatchEvent(detail);
    });

    $('.quantity-selector a[data-action="increase-product-quantity"], .quantity-selector a[data-action="decrease-product-quantity"]').click(function () {
      let unitChange;
      var parent = $(this).parents('.product__details');
      if ($(this).attr('data-action') == 'increase-product-quantity') {
        unitChange = 'Plus';
      } else {
        unitChange = 'Minus';
      }

      const detail = {
        type: 'unitChange',
        label: unitChange,
        model: parent.find(`input[name^="model_"]`).val(),
        superModel: parent.find(`input[name^="superModel_"]`).val(),
        category: parent.find(`input[name^="sixdcode_"]`).val(),
      }
      dispatchEvent(detail);
    });

    $('.form__control.variant-colour .product__available-colors input[type="radio"]').change(function () {
      const color = $(this).val();
      const detail = {
        type: 'colorSwatch',
        label: color
      }
      dispatchEvent(detail);
    });

    $('body[class^="product"] li.tabs__nav-item').click(function () {
      const tabName = $(this).html().trim();
      //there was another event for Reviews
      if (tabName !== 'Reviews') {
        const detail = {
          type: 'stickynav',
          label: tabName
        };
        dispatchEvent(detail);
      }
    });

    $('.checkout-btn .button--continue-shoping').click(function () {
      const detail = {
        type: 'continueShopping',
        label: 'continueShopping'
      }
      dispatchEvent(detail);
    });

    $('.promotion-popup a[href]:not([href="javascript:void(0)"])').click(function (event) {
      /** INFO: prevent open link before event has been fired */
      event.preventDefault();
  
      const bannerName = $('h3[aria-label="popup_heading"]').text();
      const detail = {
        type: 'popupBanner',
        label: bannerName?.trim()
      };
  
      const collectionIdsAllowTracking = window.theme.aa_tracking_collection_link_interaction;
  
      if (collectionIdsAllowTracking.length && collectionIdsAllowTracking.some((item) => item)) {
        const currentCollectionId = window.theme.collectionId;     
        const convertSettingIdToNumber = collectionIdsAllowTracking.map((id) => Number(id.trim() || 0));
        
        if (convertSettingIdToNumber.includes(currentCollectionId)) {
          dispatchEvent(detail);
        }
      }
      else {
        dispatchEvent(detail);
      }
  
      /** INFO: open link page after event was fired */
      const target = event.target;
      window.open(target.href, target.target);
  
    });  

    function dispatchEvent(dataDetail) {
      var event = new CustomEvent("linkInteraction", {	
        detail: dataDetail	
      });	

      document.dispatchEvent(event);	
    };

    // AA tracking buynow button
    $('.product__details').on('click', '.shopify-payment-button__button', async function (e) { 
      e.preventDefault();

      const selfBtn = $(this);
      var self = selfBtn.parents('.product__details');

      selfBtn.addClass('button--loading');

      // Adobe analytics Event Addtocart
      var skuValue = self.find('input[name="sku"]').val();
      var modelValue = self.find('input[name^="model_"]').val();
      var supperModelValue = self.find('input[name^="superModel_"]').val();
      var categoryValue = self.find('input[name^="sixdcode_"]').val();
      var priceValue = self.find('input[name="single-compare-at-price"]').val();
      var discountPriceValue = self.find('input[name="single-price"]').val();
      var quantityValue = self.find('input[name^="quantity"]').val();

      if (priceValue != '') {
        priceValue = priceValue;
      } else {
        priceValue = discountPriceValue;
      }

      var discountValue = Math.floor((1 - (discountPriceValue / priceValue)) * 100);
      var dataGWTProduct;

      try {
        dataGWTProduct = await getGWTdataProductDetail(`${skuValue}`, $('input[name="product-id"]').val());
      } catch (error) {
        dataGWTProduct = null;   
      }

      const detailItems = {
        sku: [skuValue],
        model: [modelValue],
        superModel: [supperModelValue],
        quantity: [quantityValue],
        category: [categoryValue],
        price: [Shopify.formatMoney(priceValue)],
        discount: [discountValue],
        discountprice: [Shopify.formatMoney(discountPriceValue)],
        loyaltyPoints: Number(Shopify.formatMoney(discountPriceValue).replace(/[^0-9.,]/g, '').replace(/,/g, '')).toString(),
        gwCategory1: [dataGWTProduct?.data?.mainCategory?.[0] || ''],
        gwCategory2: [dataGWTProduct?.data?.mainCategory?.[1] || ''],
        gwCategory3: [dataGWTProduct?.data?.mainCategory?.[2] || ''],
        gwSku: [dataGWTProduct?.data?.sku || ''],
        gwModel: [dataGWTProduct?.data?.modelName || ''],
        gwSupermodel: [dataGWTProduct?.data?.superModelName || ''],
        promoLabel: window?.productPromoLabelsList || []
      };

      var event = new CustomEvent("buyNowClick", {
        detail: detailItems 
      });
      
      document.dispatchEvent(event);
      /* Code apply for buy now button if customer logged in.
      * If don't use, on checkout page cannot use Loyalty discount.
      * Because when the buy now button is clicked, a checkout has already been created and the cart data is not the same as the checkout data.
      * */
      const buttonBuyNow = $(self).find('.shopify-payment-button[data-shopify="payment-button"]');

      if (buttonBuyNow.length) {
        const formSerializeArr = buttonBuyNow.closest('form[action^="/cart/add"]').serializeArray();

        const lineItemData = formSerializeArr.reduce((acc, {name, value}) => {
          if (name === "id") {
            return {...acc, item_id: value};
          }
          
          if (name === "quantity") {
            return {...acc, quantity: +value}
          }
  
          return acc;
        }, {});

        callAPIWithGWXToken('cart/add', 'POST', {
          is_buy_now: true,
          line_items: [lineItemData]
        }).then(result => {
          if((result?.status_code === 200 || result?.status_code === 201) && !result?.warning?.length) {
            const checkoutUrl = result.data.cart.checkout_url;
  
            if (checkoutUrl) {
              window.location.href = checkoutUrl;
            }
          } else {
            const soldoutMesg = window.languages.sold_out_message;
  
            selfBtn.text(soldoutMesg).addClass('sold-out');
  
            setTimeout(function() {
              selfBtn.text('Buy Now').removeClass('sold-out');
            }, 2500);
          }
        }).catch(err => {
          console.log("Add to cart error", err);
          
        }).finally(() => {
          selfBtn.removeClass('button--loading');
        });
      }
    });
    // AA tracking buynow button

    $(".main-menu__links > li").click(function() {

        setTimeout(function() {
            checkDevice();
        }, 500);
    });

    if ($("body").hasClass("trademark--v3")) {
        //custom product detail
        $(".product-features .block-3column").each(function() {
            var block_3column_wrapper = $(this).html();
            $(this).html("<div>" + block_3column_wrapper + "</div>");
        });

    }

    if ($("body").hasClass("template-customers-order")) {
        /**order detail**/
        var shipping_label = $(".order__items .shipping-method").attr("data-label");

        if (shipping_label != "" && shipping_label.search("Standard shipping") != -1) {
            var shipping_label_new = shipping_label.replace("Standard shipping", window.languages.standard_shipping);
            $(".order__items .shipping-method").attr("data-label", shipping_label_new);
        }
    }

    /**Validate form edit**/
    if ($("body").hasClass("trademark--v3")) {
        $(".edit-profile-btn").click(function() {

            $('.form-edit-validate').validate({
                rules: {
                    'customer[first_name]': {
                        required: true,
                        maxlength: 50
                    },

                    'customer[last_name]': {
                        required: true,
                        maxlength: 50
                    },

                    'customer[email]': {
                        required: true,
                        maxlength: 50
                    },
                    'customer[phone]': {
                        required: true,
                        maxlength: 15
                    }
                },

                submitHandler: function(form) {
                    var datakey = $("#customer-id").val();
                    var postData = {
                        "id": $("#customer-id").val(),
                        "origin": "SG",
                        "country_locale": "en_SG",
                        "first_name": $("#customer-firstname").val(),
                        "last_name": $("#customer-lastname").val(),
                        "phone": $("#customer-phone").val(),
                        "email": $("#customer-email").val()
                    }

                    var btnSignUp = $('.edit-profile-btn');
                    btnSignUp.addClass('button--loading');
                    btnSignUp.prop('disabled', true);

                    callAPIWithTokenRefresh('customers', 'post', postData, datakey)
                        .then(function(res) {
                            if (res.status) {
                                $('.alert').removeClass("alert--error");
                                $('.alert').addClass("alert--success");
                                $('.alert__title').text(window.languages.editProfileSuccess);
                            } else {
                                $('.alert').removeClass("alert--success");
                                $('.alert').addClass("alert--error");
                                if (res.message == "Invalid phone number.") {
                                    $('.alert__title').text(window.languages.edit_phone_invalid);
                                } else {
                                    $('.alert__title').text(window.languages.edit_phone_existed);
                                }

                            }
                        })
                        .finally(function(e) {
                            btnSignUp.removeClass('button--loading');
                            btnSignUp.prop('disabled', false);
                        });

                }
            });


        });

        $(".find_store__form [type='submit']").click(function() {

            $('.find_store__form').validate({
                rules: {
                    '#find-store-postcode': {
                        required: true
                    }
                },

                submitHandler: function(form) {
                    var postcode = $('#find-store-postcode').val();
                    var url = $(".find_store__form").attr("action");
                    url = url + "/?query=" + postcode;
                    window.open(url, '_blank');
                    return false;
                }
            });


        });

        $("#btnChangePassword").click(function() {
            $('.form-validate').validate({
                rules: {
                    'email': {
                        required: true,
                        email: true
                    },

                    'current_password': {
                        required: true,
                        rangelength: [8, 20]
                    },

                    'new_password': {
                        required: true,
                        rangelength: [8, 20],
                        pwcheck: "Password Valid!"
                    }
                },

                submitHandler: function(form) {
                    var postData = {
                        "id": $('#change-password input[name="customer_id"]').val(),
                        "current_password": $('#change-password input[name="current_password"]').val(),
                        "password": $('#change-password input[name="new_password"]').val()

                    }
                    var btnChangePassword = $("#btnChangePassword");
                    btnChangePassword.addClass('button--loading');
                    btnChangePassword.prop('disabled', true);

                    callAPIWithTokenRefresh('customers/change_pwd', 'put', postData)
                        .then(function(res) {
                            if (res.status) {
                                res.message = window.languages.change_password_success;
                                $('.reg--error').removeClass("alert--error");
                                $('.reg--error').addClass("alert--success");
                            } else {
                                $('.reg--error').show();
                                if (res.message == "Your password is incorrect.") {
                                    res.message = window.languages.change_password_wrong_pass;
                                } else if (res.message == "No account found with that email.") {
                                    res.message = window.languages.change_password_wrong_email;
                                } else if (res.message == "Password can not change.") {
                                    res.message = window.languages.change_password_fail;
                                }

                                $('.reg--error').removeClass("alert--success");
                                $('.reg--error').addClass("alert--error");
                            }
                            $('.reg--error--title').text(res.message);
                            $('.reg--error').show();
                        })
                        .finally(function(e) {
                            btnChangePassword.removeClass('button--loading');
                            btnChangePassword.prop('disabled', false);
                        });

                    return false;
                }
            });

            $.validator.addMethod("pwcheck", function(value, element) {
                return /^[A-Za-z0-9\d=`~!@#$%^&*\(\)_\-+=\{\}\[\];:'"\\|<>,.?\/]*$/.test(value) // consists of only these
                    &&
                    /[a-z]/.test(value) // has a lowercase letter
                    &&
                    /[A-Z]/.test(value) // has a uppercase letter
                    &&
                    /\d/.test(value) // has a digit
                    &&
                    /[`~!@#$%^&*\(\)_\-+=\{\}\[\];:'"\\|<>,.?\/]/.test(value) //has one special character without space
            }, window.languages.invalid_password);



        });

        $("#money_vat").text(Shopify.formatMoney($("#money_vat").text(), window.theme.order_money));
        $("#excluded_tax").text(Shopify.formatMoney($("#excluded_tax").text(), window.theme.order_money));

    }

    /**Multi language**/

    $(".multi-language-selector >span")
        .mouseover(function() {
            $(this).parent().addClass("open");
        })
        .mouseout(function() {
            $(this).parent().removeClass("open");
        });

    $(".multi-language-selector ul")
        .mouseover(function() {
            $(this).parent().addClass("open");
        })
        .mouseout(function() {
            $(this).parent().removeClass("open");
        });

    $("#ly-languages-switcher img").click(function() {
        $(this).parent().find("a").trigger("click");
    });


    /***Delete Address***/
    $(".delete-address").click(function() {
        if (confirm(window.languages.delete_confirm)) {
            // your deletion code
            var address_id = $(this).attr("data-address-id");

            Shopify.postLink('/account/addresses/' + address_id, { 'parameters': { '_method': 'delete' } });
        } else {
            event.preventDefault();
        }

        return false;
    });
    var RecordsPerPage = 10;

    function getDiscountList(currentPage) {
      var customerId = $(".discount-list").attr('data-customer-id');

      // $(".discount-list").css("opacity", 0);
      $(".discount-list").append("<div class='loader'></div>");

      $(".discount-paging").addClass('hidden');

      var postData = {
        "customerId": customerId,
        "CountryId": "",
        "Currency": "MYR",
        "CurrentPage": currentPage,
        "RecordsPerPage": RecordsPerPage,
        "noCache": true,
      }

      callAPIWithTokenRefresh('discounts', 'post', postData)
        .then(function (res) {
          var data = res['discounts'];
          var totalRecords = res['totalRecords'];
          var totalPage = Math.ceil(totalRecords / RecordsPerPage);

          if (currentPage > totalPage) {
            $(".discount-list .loader").remove();
            $(".discount-list").html("<p class='no-have-data'>No have data.</p>");
          }
          else {
            if (data.length > 0) {
              var html = "";
              var icon_discount = $('.icon-tag-html').html();
              var icon_copy = $('.icon-copy-html').html();

              if (icon_discount === undefined) {
                icon_discount = "";
              }
              if (icon_copy === undefined) {
                icon_copy = "";
              }
              for (let i = 0; i < data.length; i++) {
                var note = data[i].note;
                var code_name = data[i].code;
                // var code_expire = data[i].expireDate;
                
                if (code_name !== undefined && code_name != "") {
                  html += '<div class="discount-item">';
                  html += '<ul class="discount-item-wrap">';
                  html += '<li class="code-value">CODE: ' + icon_discount;
                  html += '<span class="copy-code" data-value="' + code_name + '">' + code_name + icon_copy + "</span>";
                  html += '</li>';
                  // if (code_expire !== undefined && code_expire != "") {
                  //   html += '<li class"code-expire">Ngày hết hạn: ' + dateToYMD(code_expire) + '</li>';
                  // }

                  if (note !== undefined && note != "") {
                    // html += '<ul class="code-content">';
                    html += '<li class="note-discount">' + note + '</li>';
                    // html += '<span class="detail">Detail</span>';
                    // html += '</ul>';
                  }
                  html += '</ul>';
                  html += '</div>';
                }
              }

              $(".discount-list").html(html);

              showCodeContent();

              $(".code-content .detail").click(function (e) {
                $(this).parent().removeClass("has-more");

                if ($(this).parent().find("p").innerHeight() > 105) {
                  $(this).parent().css({ "overflow-y": "scroll", "max-height": "105px" });
                }

                $(this).remove();
              });

              // $(".discount-list").css("opacity", 1);

              $(".icon-copy").click(function (e) {
                $(".copied-text").remove();
                $(".copy-code").removeClass('copied');
                var parent = $(this).parent();
                parent.addClass("copied");
                e.preventDefault();
                var copied_text = "<span class='copied-text'>Copied</span>";

                // Select the text
                var copied;
                const el = document.createElement('textarea');
                el.value = parent.attr('data-value');
                document.body.appendChild(el);
                el.select();

                try {
                  // Copy the text
                  copied = document.execCommand('copy');
                  document.body.removeChild(el);
                }
                catch (ex) {
                  copied = false;
                }

                if (copied) {
                  parent.append(copied_text);
                  $(".copy-code").addClass('copied');
                  setTimeout(function () {
                    $(".copied-text").remove();
                    $(".copy-code").removeClass('copied');
                  }, 500);
                }
              });
            }
            else {
              $(".discount-list").html("<p class='no-have-data'>No have data.</p>");
            }
          }
          showNavigation(currentPage, totalPage);

          // $(".discount-list").css("opacity", 1);
        })
    }

    function showNavigation(currentPage, totalPage) {
      if (currentPage > totalPage || totalPage <= 1) {
        //hide navigation
        $(".discount-paging .pagination").remove();
      }
      else {
  
        //show navigation
        var html = "";
        var prev = parseInt(currentPage) - 1;
        var next = parseInt(currentPage) + 1;
        $(".pagination__prev").hide();
        $(".pagination__next").hide();
        if (currentPage > 1) {
          $(".pagination__prev").show();
          $(".pagination__prev").attr("href", "/pages/your-discount-codes?page=" + prev);
        }
        if (currentPage < totalPage) {
          $(".pagination__next").show();
          $(".pagination__next").attr("href", "/pages/your-discount-codes?page=" + next);
        }
  
  
        for (i = 1; i <= totalPage; i++) {
          if (currentPage == i) {
            html += '<li class="pagination__nav-item pagination__nav-item--active">';
            html += '<span>' + i + '</span>';
            html += '</li>';
          }
          else {
            html += '<li class="pagination__nav-item">';
            html += '<a rel="' + i + '" href="/pages/your-discount-codes?page=' + i + '" class="pagination__nav-link link"><span>' + i + '</span></a>';
            html += '</li>';
          }
  
        }
  
        if (html != "") {
          $(".pagination__nav").html(html);
        }
      }
  
      $(".discount-paging").removeClass('hidden');
  
    }

    function showCodeContent(resize = false) {
        $(".discount-item").each(function() {
            var code_content = $(this).find('.code-content > p').innerHeight();
            if (code_content > 66 && !resize) {
                $(this).find('.code-content').addClass('has-more');
                $(this).find('.code-content .detail').show();
            }
            if ($(this).find('.code-content p').innerHeight() > 105) {
                $(this).find('.code-content').css({ "overflow-y": "scroll", "max-height": "105px" });
            } else {
                $(this).find('.code-content').css({ "overflow-y": "auto", "max-height": "none" });
            }
        });
    }

    function showReview(isActive) {
        var id = setInterval(check, 1000);
        var i = 0;
        var k = 1;

        function check() {
            if (isActive) {
                i = 9;
            }
            if (k == 5) {
                isActive = false;
            }

            if (i >= 10) {
                clearInterval(id);
            } else {
                if ($(window).innerWidth() > 800) {
                    if (!$('#product-review-m').is(':empty')) {
                        //do something
                        var html = $("#product-review-m").html();
                        $("#product-review").html(html);
                        i = 10;
                        k++;
                        //             hideReviewPdp();
                    }
                } else {
                    if (!$('#product-review').is(':empty')) {
                        var html = $("#product-review").html();
                        $("#product-review-m").html(html);
                        i = 10;
                        k++;
                        //            hideReviewPdp();
                    }
                }
                i++;
            }
        }
    }

    /**Show review tab after clicking star**/


    window.bvCallback = function(BV) {

        BV.swat_reviews.on('show', function() {
            if ($(window).innerWidth() > 800) {
                $('.tabs__nav-item.review-tab-title').click();

                setTimeout(function() {
                    $('html, body').animate({
                        scrollTop: $(".product__tabs").offset().top - 100
                    }, 0);

                }, 100);

            } else {
                if (!$(".tabs__nav-item-m > .review-tab-title").hasClass("active")) {
                    $('.tabs-title.review-tab-title').click();
                }

                setTimeout(function() {
                    $('html, body').animate({
                        scrollTop: $(".tabs-title.review-tab-title").offset().top - 100
                    }, 0);

                }, 100);

            }


            return false;

        });

    };


    /**Hide no review***/
    function hideNoRating() {
        $(".product-item").each(function() {

            //var inline_rating = $(this).find('[data-bv-show="inline_rating"]');
            var bv_text = $(this).find('.bv_text').text();


            if (bv_text != '' && bv_text != '(0)') {
                //         inline_rating.hide();
                $(this).find(".bv-ratings-block").addClass("show");
            }

        });


    }

    function hideReviewPdp() {
        if ($(".bv_numReviews_text").length) {
            if ($(".bv_numReviews_text").text() == '(0)') {
                //         $('[data-bv-show="rating_summary"]').hide();
                $(".review-tab-title").hide();
                $(".review-tab-m").parents(".tabs__nav-item-m").hide();
            } else {
                $(".product__meta .bv-ratings-block").addClass("show");
                $(".review-tab-title").show();
                $(".review-tab-m").parents(".tabs__nav-item-m").show();

            }

        }
    }

    function checkRating() {
        var id = setInterval(check, 1000);
        var i = 0;

        function check() {
            if (i >= 15) {
                clearInterval(id);
            } else {
                hideNoRating();
                hideReviewPdp();
                i++;
            }
        }
    }


    /**
     * js cateogry mobile
     */
    $(document).ready(function() {
        setWidthCategoryMobile();
        var router = new RouterRouter();
      	router.route('products/*type', productRouteCs);
    	router.route('collections/*type', productRouteCs);

        $.each($('.label._coming_soon_label'), function(index, ele){
            let btnAddToCart = $(ele).parents('.product-item').find('.product__add-to-cart');
            btnAddToCart.attr("disabled", true);
            btnAddToCart.text("Coming Soon");
            btnAddToCart.parents(".product__form").removeAttr('method action');
          })
    });

    var setWidthCategoryMobile = function() {
        var widthBrowser = $(window).width();
        if (widthBrowser < 768) {
            var categoryItem = $(".js-list-category-mobile .category-item");
            var withcategoryItem = categoryItem.width(widthBrowser * 0.21);
            $(".shopify-section__category-list-mobile").css('display', 'block');
            $(".js-list-category-mobile").width(categoryItem.length * withcategoryItem);
        } else {
            $(".js-list-category-mobile").width('auto');
        }
    }

    var productRouteCs = function(){
        $.each($('.label._coming_soon_label'), function(index, ele){
          let btnAddToCart = $(ele).parents('.grid-product-info').find('.product__add-to-cart');
          btnAddToCart.attr("disabled", true);
          btnAddToCart.text("Coming Soon");
          btnAddToCart.parents(".product__form").removeAttr('method action');
        })
        
        $relatedProduct = $('#shopify-section-related-products');
        $recommendationsProduct = $('#shopify-section-product-recommendations');
        if($relatedProduct.find('.container').length > 0 ){
          $recommendationsProduct.remove();
        }

    }
    
  /**
   * Logout user after a certain period of inactivity
   */
  $(function() {
    const isLoggedIn = window.theme.isLoggedIn;

    if (isLoggedIn) {
      handleInactivity();
    }
  });

  function handleInactivity() {
    let idleTime = 0; // Timer to track idle time in minutes
    let maxIdleTime = "30" || 30; // Maximum idle time in minutes (adjust as needed)

    // Function to reset idle time
    function resetIdleTime() {
      idleTime = 0;
    }

    // Function to log out the user
    function logoutUser() {
      window.location.href = "https://www.sony.com.sg/mysony/sg/logoutredirect?returnUri=https://store.sony.com.sg/account/logout"; // Redirect to logout URL
    }

    // Reset idle time on any user activity
    document.onmousemove = resetIdleTime;
    document.onkeydown = resetIdleTime;
    document.onclick = resetIdleTime;
    document.onscroll = resetIdleTime;
   
    // Check idle time at regular intervals (every minute)
    const intervalId = setInterval(function () {
      idleTime++;

      if (idleTime >= maxIdleTime) {
        clearInterval(intervalId);
        logoutUser(); // Log out if idle time exceeds maxIdleTime
      }
    }, 60000); // Check every 60 seconds (1 minute)
  }

}(jQuery));
